import {memo, useEffect} from "react";
import {useHistory, useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTable} from "../../../../property_list/PropertyListTable";
import {useAppSelector} from "../../../../store/hooks";
import {IOfferDetail} from "../../../types/IOfferDetail";
import {PropertyListTabTypes} from "../../actions/fetch_offer_detail_properties";

interface IProps {
    offerId: number;
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmMeta: {
        listId: string;
        listName: string;
    };
}

export const propertyListTableFiltersFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox
    // construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTable = memo((props: IProps) => {
    const {propertyListObj, offer, gtmMeta, filterValues} = props;
    const {pageCount, onPageChange, onSortChange, sort, tab, page, requestState, properties, pageIsLoading} = propertyListObj;

    const activeTab = useAppSelector((store) => store.offerDetail.properties.activeTab);

    const location = useLocation();
    const prevLocation = usePrevious(location, location);
    const history = useHistory();
    const {isMobile} = useUserDevice();

    const handlePageChange = async (value: number): Promise<unknown[] | void> => {
        // INVESTMENT tab does not support filtering (investment properties with ROI) so avoid propagating filter params
        const filterQueryValues = activeTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, filterValues) : {};
        return await onPageChange(value, filterQueryValues);
    };

    const handleSortChange = (value: string) => {
        // INVESTMENT tab does not support filtering (investment properties with ROI) so avoid propagating filter params
        const filterQueryValues = activeTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, filterValues) : {};
        onSortChange(value, filterQueryValues);
    };

    useEffect(() => {
        if (!prevLocation.hash && location.hash === "#nieruchomosci") {
            history.replace(location.pathname + location.search);
            tab.setCurrentTab(PropertyListTabTypes.INVESTMENT);
        }
    }, [location]);

    return (
        <>
            {offer && (
                <PropertyListTable
                    caption={`Dostępne lokale w inwestycji ${offer.name}`}
                    requestState={requestState}
                    offer={offer}
                    properties={properties}
                    sort={sort.currentSort}
                    onSortChange={handleSortChange}
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    pageIsLoading={pageIsLoading}
                    currentPage={page.currentPage}
                    gtmMeta={{
                        listId: gtmMeta.listId,
                        listName: gtmMeta.listName
                    }}
                />
            )}

            {pageCount > 0 && (
                <Pagination
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});
import {memo, useEffect} from "react";
import {useHistory, useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {usePrevious} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTable} from "../../../../property_list/PropertyListTable";
import {useAppSelector} from "../../../../store/hooks";
import {IOfferDetail} from "../../../types/IOfferDetail";
import {PropertyListTabTypes} from "../../actions/fetch_offer_detail_properties";

interface IProps {
    offerId: number;
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmMeta: {
        listId: string;
        listName: string;
    };
}

export const propertyListTableFiltersFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox
    // construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTable = memo((props: IProps) => {
    const {propertyListObj, offer, gtmMeta, filterValues} = props;
    const {pageCount, onPageChange, onSortChange, sort, tab, page, requestState, properties, pageIsLoading} = propertyListObj;

    const activeTab = useAppSelector((store) => store.offerDetail.properties.activeTab);

    const location = useLocation();
    const prevLocation = usePrevious(location, location);
    const history = useHistory();
    const {isMobile} = useUserDevice();

    const handlePageChange = async (value: number): Promise<unknown[] | void> => {
        // INVESTMENT tab does not support filtering (investment properties with ROI) so avoid propagating filter params
        const filterQueryValues = activeTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, filterValues) : {};
        return await onPageChange(value, filterQueryValues);
    };

    const handleSortChange = (value: string) => {
        // INVESTMENT tab does not support filtering (investment properties with ROI) so avoid propagating filter params
        const filterQueryValues = activeTab !== PropertyListTabTypes.INVESTMENT ? toQueryValues(propertyListTableFiltersFields, filterValues) : {};
        onSortChange(value, filterQueryValues);
    };

    useEffect(() => {
        if (!prevLocation.hash && location.hash === "#nieruchomosci") {
            history.replace(location.pathname + location.search);
            tab.setCurrentTab(PropertyListTabTypes.INVESTMENT);
        }
    }, [location]);

    return (
        <>
            {offer && (
                <PropertyListTable
                    caption={`Dostępne lokale w inwestycji ${offer.name}`}
                    requestState={requestState}
                    offer={offer}
                    properties={properties}
                    sort={sort.currentSort}
                    onSortChange={handleSortChange}
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    pageIsLoading={pageIsLoading}
                    currentPage={page.currentPage}
                    gtmMeta={{
                        listId: gtmMeta.listId,
                        listName: gtmMeta.listName
                    }}
                />
            )}

            {pageCount > 0 && (
                <Pagination
                    onPageChange={handlePageChange}
                    pageCount={pageCount}
                    currentPage={page.currentPage}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});
